import { render, staticRenderFns } from "./ReportAgent.vue?vue&type=template&id=2800ea47"
import script from "./ReportAgent.vue?vue&type=script&lang=js"
export * from "./ReportAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports